import {H, P, ViewCopy, ViewDialog} from "../components/view.tsx";
import NumberInput from "../components/inputs/input-number.tsx";
import { Button } from "../components/button.tsx";
import {ReactNode, useEffect, useContext} from "react";
import { useStore } from "../state/state.ts";
import { PdfLink } from "../components/pdf-link.tsx";
import PropertyInput from "../components/inputs/input-property.tsx";
import { format_1000 } from "../functions.ts";
import { ConfigContext } from "../config_context.ts";

export default function ViewCalculation() {
  const foerderung = useContext(ConfigContext).foerderung;

  const savings_percentage = useStore((state)=>state.savings_percentage); 
  const monthly_possible_savings = useStore((state)=>state.monthly_possible_savings); 
  const period_under_review_savings = useStore((state)=>state.period_under_review_savings); 
  const annual_energy_consumption_kwh_current = useStore((state)=>state.annual_energy_consumption_kwh_current); 
  const annual_energy_consumption_kwh_planned = useStore((state)=>state.annual_energy_consumption_kwh_planned); 
  const energy_efficiency_class_current = useStore((state)=>state.energy_efficiency_class_current); 
  const energy_efficiency_class_planned = useStore((state)=>state.energy_efficiency_class_planned); 
  const co2_emission_current = useStore((state)=>state.co2_emission_current); 
  const co2_emission_planned = useStore((state)=>state.co2_emission_planned); 

  const total_planned_costs = useStore((state)=>state.total_planned_costs); 
  const total_possible_subsidy = useStore((state)=>state.total_possible_subsidy); 

  const annual_savings_on_energy_costs = useStore((state)=>state.annual_savings_on_energy_costs); 
  const total_investment_costs = useStore((state)=>state.total_investment_costs); 
  const total_beg_subsidy = useStore((state)=>state.total_beg_subsidy); 
  const total_final_costs = useStore((state)=>state.total_final_costs); 

  const co2_tax_savings = useStore((state)=>state.co2_tax_savings); 
  const savings_over_lifetime = useStore((state)=>state.savings_over_lifetime); 

  const payback_period = useStore((state)=>state.payback_period);
  const annual_profit_loss = useStore((state)=>state.annual_profit_loss);
  const monthly_profit_loss = useStore((state)=>state.monthly_profit_loss);
  const kostensteigerung_energie = useStore((state)=>state.kostensteigerung_energie);
  const period_unter_review = useStore((state)=>state.period_unter_review);
  const period_under_review_energy_savings = useStore((state)=>state.period_under_review_energy_savings);

  const co2_price = useStore((state)=>state.co2_price);

  const pv_area = useStore((state)=>state.pv?.area);
  const pv_elec_annual_savings = useStore((state)=>state.pv?.elec_annual_savings);
  const pv_elec_self_consumption = useStore((state)=>state.pv?.elec_self_consumption);
  const annual_pv_production_kwh_adjusted = useStore((state)=>state.annual_pv_production_kwh_adjusted ?? 0);
  const annual_pv_production_kwh_planned = useStore((state)=>state.annual_pv_production_kwh_planned ?? 0);

  const api_profitability_calculation = useStore((state)=>state.api_profitability_calculation);
  const return_on_investment = useStore((state)=>state.return_on_investment);
  
  useEffect(()=>{
    api_profitability_calculation();
  },[kostensteigerung_energie, co2_price]);

  return (<ViewDialog>
            <ViewCopy><H>Ergebnisse und Einsparungen im Überblick</H><P>So rechnen sich die simulierten Sanierungen: Die Investitionskosten und {foerderung ? "eine mögliche Bundesförderung sowie die" : ""} Einsparpotentiale von Energie und CO2-Steuer – alle Ergebnisse auf einem Blick.</P></ViewCopy>
            <div className="calc_view">
              <table 
                className="table"
                role="table"
                aria-rowcount={3}>
                <tbody>
                  <TableRow><D>Investitionskosten gesamt</D><D>{format_1000(Math.round(total_planned_costs))} €</D></TableRow>
                  {foerderung && <TableRow><D>BEG-Förderung gesamt</D><D>{format_1000(Math.round(total_possible_subsidy))} €</D></TableRow>}
                  {foerderung && <TableRow><D>Investition nach Förderung</D><D>{format_1000(Math.round(total_final_costs))} €</D></TableRow>}                
                </tbody>
              </table>

              <br/>

              <PropertyInput placeholder_prefix="ca." type="kostensteigerung_energie"/>
              <table 
                className="table"
                role="table"
                aria-rowcount={2}
                >
                <tbody>     
                  <TableRow><D>Gewinn / Verlust</D><D>
                    <div className="td-two">
                      <div><span>monatlich</span><span>{format_1000(monthly_profit_loss  || 0)}  €</span></div> 
                      <div><span>jährlich</span><span>{format_1000(annual_profit_loss  || 0)} €</span></div> 
                    </div>
                  </D></TableRow>
                  <TableRow><D>Einsparungen Energiekosten*</D><D>{format_1000(period_under_review_energy_savings || 0)} €</D></TableRow>
                </tbody> 
              </table>

              <br/>

               { (annual_pv_production_kwh_adjusted || annual_pv_production_kwh_planned) && <>
                <table className="table">
                    <tbody>     
                      <TableRow><D>verschattungsfreie Dachfläche</D><D>min. {format_1000(pv_area || 0)} m²</D></TableRow>
                      <TableRow><D>Produktion PV-Strom</D><D>{format_1000(annual_pv_production_kwh_planned|| 0)} kWh/Jahr</D></TableRow>
                      <TableRow><D>Eigenverbrauch</D><D>{format_1000(pv_elec_self_consumption || 0)} kWh/Jahr</D></TableRow>
                      <TableRow><D>jährliche Einsparung Photovoltaik</D><D>{format_1000(pv_elec_annual_savings || 0)} €</D></TableRow>
                    </tbody>
                  </table>
                  <br/>
                  </>
              }

              <PropertyInput placeholder_prefix="ca." type="co2_price"/>
              <table 
                className="table"
                role="table"
                aria-rowcount={1}>
                <tbody>
                  <TableRow><D>CO₂-Steuerersparnis*</D><D>{format_1000(co2_tax_savings ||  0)} €</D></TableRow>
                </tbody>
              </table>

              <br/>

              <table 
                className="table"
                role="table"
                aria-rowcount={3}
                >
                <tbody>
                  {payback_period && <TableRow><D>Amortisationsdauer</D><D>{format_1000(payback_period)} Jahre</D></TableRow>}
                  <TableRow><D>mittlere Rendite</D><D>{format_1000(return_on_investment ||  0)} %</D></TableRow>
                  <TableRow><D>Einsparung gesamt*</D><D>{format_1000(savings_over_lifetime ||  0)}  €</D></TableRow>
                </tbody>
              </table>

              <p className="input_hint">
                  *) über die Nutzungsdauer von 40 Jahren <br/>
                     die Nutzungsdauer bei Heizung, Solar, Photovoltaik und Lüftung beträgt ca. 20 Jahre
                </p>
                <div style={{height: "2rem"}}></div>
            </div>
            
            {/* <Button label="Bericht anzeigen" onClick={()=>{}} style={{marginLeft: "auto"}}/> */}
            <PdfLink/>
         </ViewDialog>)
}


export function TableRow(props:{children: ReactNode}) {
  return <tr role="row">
            <td role="cell">{props.children[0]}</td>
            <td role="cell">{props.children[1]}</td>
         </tr> 
}

export function D(props:{children: ReactNode}) {
  return <span>{props.children}</span>
}


